import { Box } from '@mui/material';

import DetailsItem from '../../../../../../common/details-item';
import { formatDateToClientFormat } from '../../../../../../../constants/helpers/dates';
import { reportDetailsFilterValuesFormatter } from '../../../../../../../utils/details';

import locales from '../locales';
import { VoiceReportDetailsMetaDataResponse } from '../interfaces';
// eslint-disable-next-line max-len
import { convertVoiceSessionCloseReasonQueryToReadableFormat } from '../../../../../../common/table/utils/operationTypeFormatters';

interface Props {
  filters: VoiceReportDetailsMetaDataResponse;
}

const FilterDetails = ({ filters }: Props) => (
  <Box>
    <DetailsItem
      label={locales.details.startingDate.label}
      value={formatDateToClientFormat({ date: filters.timeRange.from })}
    />
    <DetailsItem
      label={locales.details.endDate.label}
      value={formatDateToClientFormat({ date: filters.timeRange.to, type: 'exclusive' })}
    />
    <DetailsItem
      label={locales.details.operators.label}
      value={reportDetailsFilterValuesFormatter(filters.operators)}
    />
    <DetailsItem label={locales.details.appIds.label} value={reportDetailsFilterValuesFormatter(filters.voiceAppIds)} />
    <DetailsItem
      label={locales.details.operationIds.label}
      value={reportDetailsFilterValuesFormatter(filters.operationIds)}
    />
    <DetailsItem
      label={locales.details.phoneNumbers.label}
      value={reportDetailsFilterValuesFormatter(filters.msisdns)}
    />
    <DetailsItem
      label={locales.details.sessionTags.label}
      value={reportDetailsFilterValuesFormatter(filters.sessionTags)}
    />
    <DetailsItem
      label={locales.details.sessionCloseReasons.label}
      value={reportDetailsFilterValuesFormatter(
        filters.sessionCloseReasons.map(value => convertVoiceSessionCloseReasonQueryToReadableFormat(value))
      )}
    />
  </Box>
);

export default FilterDetails;
